import React from 'react';
import Header from './Header/Header';
import { Outlet } from 'react-router-dom';
import "./MainMaster.css";
import Footer from './Footer/Footer';
import { isMobile } from 'react-device-detect';
import DesktopFooter from './Footer/DesktopFooter/Footer';
const MainMaster = () => {
  return (
    <>
        <section className="home-main-area">
        <Header></Header>
        <Outlet></Outlet>
        {isMobile ?  <Footer /> :  <DesktopFooter />}
       
      </section>
    </>
  );
};

export default MainMaster;